export default __webpack_public_path__ + "static/media/policies-sold.0b1908c23f7151cb9669e0ce4e991966.0b1908c2.svg";